export const languageSwitcherItems: Record<string, string> = {
  ru: 'Русский',
  en: 'English',
  es: 'Español',
};

export const PRIMARY_LANG = window._env_.VITE_PRIMARY_LANGUAGE || import.meta.env.VITE_PRIMARY_LANGUAGE || 'en';
export const SECONDARY_LANG = window._env_.VITE_SECONDARY_LANGUAGE || import.meta.env.VITE_SECONDARY_LANGUAGE;
